<div class="header">{{ text | translate }}</div>
